import { LucideIcon } from 'lucide-react'
import type {
  FacetedItem,
  FacetedFilterState,
  FacetedViewMode,
} from '../../../../shared/useFacetedExplorer'

export interface RegistryCategory {
  id: string
  label: string
  icon: LucideIcon
  description?: string
  items: string[]
}

/**
 * Admin question-bank explorer item.
 *
 * Extends the generic {@link FacetedItem} (shared across portals) with
 * admin-specific fields used in the visuals/types tabs.
 */
export interface ExplorerItem extends FacetedItem {
  description: string
  icon: LucideIcon
  // Specific to Visuals
  stimulusCount?: number
  supportCount?: number
  // Specific to Types
  familyCount?: number
}

/** Backwards-compatible alias for the generic faceted-filter shape. */
export type FilterState = FacetedFilterState

/** Backwards-compatible alias for the generic view-mode union. */
export type ViewMode = FacetedViewMode
